import { apiRequest } from "@/features/api/apiClient";
import type {
  LaunchReadinessChecklistRequest,
  LaunchReadinessChecklistResponse,
  LaunchReadinessRequest,
  MonetisationModelRequest,
  ProToolPlaceholderResponse,
  SalesHeadlineRequest,
  ToolCatalogResponse,
  ToolResultResponse,
  ToolResultsResponse,
} from "@/features/tools/proToolTypes";

export function getProToolCatalog(
  token: string | null,
): Promise<ToolCatalogResponse> {
  return apiRequest<ToolCatalogResponse>("/api/tools", { token });
}

export function listProToolResults(
  token: string | null,
): Promise<ToolResultsResponse> {
  return apiRequest<ToolResultsResponse>("/api/tools/results", { token });
}

export function getProToolResult(
  token: string | null,
  resultId: string,
): Promise<ToolResultResponse> {
  return apiRequest<ToolResultResponse>(`/api/tools/results/${resultId}`, {
    token,
  });
}

export function callProToolPlaceholder(
  token: string | null,
  toolSlug: string,
): Promise<ProToolPlaceholderResponse> {
  return apiRequest<ProToolPlaceholderResponse>(`/api/tools/${toolSlug}`, {
    method: "POST",
    token,
  });
}

export function generateLaunchReadinessChecklist(
  token: string | null,
  input: LaunchReadinessChecklistRequest,
): Promise<LaunchReadinessChecklistResponse> {
  return apiRequest<LaunchReadinessChecklistResponse>(
    "/api/tools/launch-readiness-checker/checklist",
    {
      method: "POST",
      token,
      body: input,
    },
  );
}

export function runLaunchReadinessChecker(
  token: string | null,
  input: LaunchReadinessRequest,
): Promise<ToolResultResponse> {
  return apiRequest<ToolResultResponse>("/api/tools/launch-readiness-checker", {
    method: "POST",
    token,
    body: input,
  });
}

export function runMonetisationModelSuggester(
  token: string | null,
  input: MonetisationModelRequest,
): Promise<ToolResultResponse> {
  return apiRequest<ToolResultResponse>(
    "/api/tools/monetisation-model-suggester",
    {
      method: "POST",
      token,
      body: input,
    },
  );
}

export function runSalesHeadlineGenerator(
  token: string | null,
  input: SalesHeadlineRequest,
): Promise<ToolResultResponse> {
  return apiRequest<ToolResultResponse>(
    "/api/tools/sales-page-headline-generator",
    {
      method: "POST",
      token,
      body: input,
    },
  );
}
